import { SVG, SVGProps } from './svg'

export function IconSignOut(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M5 19h5.5c.3 0 .5.2.5.5v1c0 .3-.2.5-.5.5H5a2 2 0 01-2-2V5c0-1.1.9-2 2-2h5.5c.3 0 .5.2.5.5v1c0 .3-.2.5-.5.5H5v14zM15.6 6.2l5.2 5 .2.6v.4c0 .2 0 .4-.2.5L15.6 18a.5.5 0 01-.7 0l-.7-.8a.5.5 0 010-.7l3.5-3.4H7.5a.5.5 0 01-.5-.5v-1c0-.3.2-.5.5-.5h10.2l-3.5-3.4a.5.5 0 010-.7L15 6a.5.5 0 01.7 0z" />
    </SVG>
  )
}
